import {
    USER_AUTHORIZE,
    USER_REQUEST,
    USER_LOGOUT,
    USER_UPDATE_MAIL,
    USER_UPDATE_NOTIFY_SETTINGS
} from 'actions/user';

import {
    USER_SET_STATUS,
    USER_REQUESTED,
    USER_SET_NOTIFY_SETTINGS,
    USER_UPDATE
} from 'mutations/user';

import { SWITCH_LOCALE } from 'actions/i18n';

import Vue from 'vue';
import api from '@/api';

const defines = require('../../../libs/defines');

const state = { status: '', profile: null };

const actions = {
    [USER_AUTHORIZE]: async ({ commit, dispatch }) => {
        try {
            let response = await api.get('/app/authorized');

            if (response.data.authorized)
                commit(USER_SET_STATUS, defines.AUTHORIZE_STATUS.ACCOUNT_EXISTS);
            else
                commit(USER_SET_STATUS, defines.AUTHORIZE_STATUS.UNAUTHORIZED);
        }
        catch (e) {
            commit(USER_SET_STATUS, defines.AUTHORIZE_STATUS.UNAUTHORIZED);
        }
    },

    [USER_REQUEST]: async ({ commit, dispatch }) => {
        try {
            let user = null;

            let response = await api.get('/app/account');

            if (response.data) {
                user = response.data;

                if (user.locale)
                    await dispatch(`i18n/${SWITCH_LOCALE}`, user.locale, { root: true });
            }

            commit(USER_SET_STATUS, defines.AUTHORIZE_STATUS.AUTHORIZED);
            commit(USER_REQUESTED, user);
        }
        catch (e) {
            commit(USER_SET_STATUS, defines.AUTHORIZE_STATUS.UNAUTHORIZED);
        }
    },

    [USER_LOGOUT]: async ({ commit, dispatch }) => {
        let response = await api.post('/app/logout');

        if (response && response.status === defines.RESPONSE_STATUS.OK)
            window.location = `${response.data}/app/account/logout?redirect=${window.location.origin}`;
    },

    [USER_UPDATE_MAIL]: async (context, mail) =>
        await api.post('/app/account/mail', {
            mail
        }),

    [USER_UPDATE_NOTIFY_SETTINGS]: async ({ commit, dispatch }, update) => {
        commit(USER_SET_NOTIFY_SETTINGS, update);

        await api({
            method: 'post',
            url: '/app/account/notifications/disabledTypes',
            data: { disabledTypes: update }
        });
    }
};

const mutations = {
    [USER_SET_STATUS]: (state, status) => {
        state.status = status;

        if (status === defines.AUTHORIZE_STATUS.UNAUTHORIZED)
            state.profile = null;
    },
    [USER_REQUESTED]: (state, user) => {
        Vue.set(state, 'profile', user);
    },
    [USER_SET_NOTIFY_SETTINGS]: (state, update) => {
        if (update !== undefined)
            state.profile.disabledNotificationTypes = update;
    },
    [USER_UPDATE]: (state, update) => {
        if (update.name !== undefined)
            state.profile.name = update.name;

        if (update.surname !== undefined)
            state.profile.surname = update.surname;

        if (update.mail !== undefined)
            state.profile.mail = update.mail;

        if (update.phone !== undefined)
            state.profile.phone = update.phone;

        if (update.work !== undefined)
            state.profile.work = update.work;

        if (update.position !== undefined)
            state.profile.position = update.position;

        if (update.vkId !== undefined)
            state.profile.vkId = update.vkId;

        if (update.passwordExists !== undefined)
            state.profile.passwordExists = update.passwordExists;

        if (update.permissions !== undefined)
            state.profile.permissions = update.permissions;

        if (update.preferredMailingMethod !== undefined)
            state.profile.preferredMailingMethod = update.preferredMailingMethod;

    }
};

const getters = {
    status(state) {
        return state.status;
    },
    profile(state) {
        return state.profile
            ? { ...state.profile, mailExists: !!state.profile.mail }
            : null;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
